import { cn } from '@/common/lib/cn/cn'
import { formatBlockDeltaBadge, formatDeltaBadge, type DeltaResult } from '../../lib/brandComparison'

type BrandComparisonDeltaBadgeProps = {
    delta: DeltaResult
    variant?: 'summary' | 'block' | 'gap'
    fractionDigits?: number
    suffix?: string
    brandAName?: string
    brandBName?: string
    className?: string
}

export const BrandComparisonDeltaBadge = ({
    delta,
    variant = 'summary',
    fractionDigits = 1,
    suffix = '',
    brandAName = '',
    brandBName = '',
    className,
}: BrandComparisonDeltaBadgeProps) => {
    if (delta.sign === 'equal') {
        return (
            <span
                className={cn(
                    'inline-flex items-center rounded-md bg-white/10 px-2 py-0.5 text-xs font-medium text-base-content/60',
                    className
                )}
            >
                ≈ равно
            </span>
        )
    }

    const isPositiveForA = delta.raw > 0
    const toneClass = isPositiveForA ? 'bg-[#08AC81]/15 text-[#08AC81]' : 'bg-[#FF484B]/15 text-[#FF484B]'

    const label =
        variant === 'block'
            ? formatBlockDeltaBadge(delta, brandAName, brandBName)
            : variant === 'gap'
              ? `Δ ${Math.round(delta.value)}%`
              : `Δ ${formatDeltaBadge(delta, { fractionDigits, suffix })}`

    return (
        <span
            className={cn(
                'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium tabular-nums whitespace-nowrap',
                toneClass,
                className
            )}
        >
            {label}
        </span>
    )
}
